import React, { useEffect, useState } from "react";

import { useAuthGlobal } from "../../../../../../contexts/auth-context/auth-context";

import { DocumentsResponseModel } from "../../../../../../domain/models/documents";
import { FilterModel } from "../../../../../../domain/models/enum";

import DocumentsListPage from "../../../../../../presentation/pages/developer/documents/list";

import { settings } from "../../../../../configs/settings";

import { makeRemoteDocument } from "../../../../usecases/documents/remote-documents-factory";

import { generateFilter } from "./utils";
import { makeRemoteDeveloperCompanies } from "../../../../usecases/developer-companies/remote-developer-companies-factory";

function MakeDocumentsList(): JSX.Element {
  const { profile, user } = useAuthGlobal();
  const [list, setList] = useState<DocumentsResponseModel>();
  const [params, setParams] = useState<FilterModel>({});
  const [loading, setLoading] = useState<boolean>();
  const [reload, setReload] = useState<boolean>(false);

  const loadData = async (): Promise<void> => {
    try {
      setLoading(true);

      const developerCompaniesData =
        await makeRemoteDeveloperCompanies().getByDeveloper();

      const data = await makeRemoteDocument().load({
        size: settings.perPage,
        sort: "issuedOn,desc",
        page: params?.page,
        query: params?.query,
        filters: generateFilter({
          ...params?.filters,
          developerCompany: developerCompaniesData[0]?.id,
        }),
      });
      setList(data);
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, profile, user, reload]);

  const handleReload = (): void => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleReload();
    }, 180000);
    return () => clearInterval(interval);
  }, []);

  return (
    <DocumentsListPage
      // params={params}
      list={list}
      setParams={setParams}
      loading={loading}
      handleReload={handleReload}
    />
  );
}

export default MakeDocumentsList;
